import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";

import { useCastersContext } from "../../../CastersContext";
import { useTableStyles } from "../../../styles/useTableStyles";
import { useElementTableData } from "./hooks/useElementTableData";
import { useElementStyles } from "./styles/useElementStyles";

export const ElementTable = () => {
	const commonTableClasses = useTableStyles();
	const localClasses = useElementStyles();
	const { state } = useCastersContext();

	const elementList = state.elements || [];

	const { columns, rowData, getRowStyle } = useElementTableData({
		elementList,
	});

	const gridHeight = 20 + rowData.length * 41 + 2;
	const minHeight = 227;

	return (
		<>
			<Paper className={commonTableClasses.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div
						className={`${commonTableClasses.materialTable}`}
						style={{
							height: `${Math.max(gridHeight, minHeight)}px`,
							minWidth: "100%",
						}}
					>
						<AgGridReact
							rowData={rowData}
							columnDefs={columns}
							suppressPaginationPanel={true}
							suppressContextMenu
							cellSelection
							copyHeadersToClipboard
							enableCellTextSelection
							getRowId={(params) => params.data.id}
							getRowStyle={getRowStyle}
							noRowsOverlayComponent={() => "No chemistry data available"}
						/>
					</div>
				</Box>
			</Paper>
		</>
	);
};
